import { Step } from 'react-joyride';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import startCase from 'lodash/startCase';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BadgeStatus } from '@mgm/common/components/base';
import { TourGuide } from '../../../../components';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';

type TTimesheetsTour = {
  runTour: boolean
  setRunTour: (val: boolean) => void
};

const TimesheetsTour: FC<TTimesheetsTour> = ({ runTour, setRunTour }) => {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const { t } = useTranslation('tour');

  const tourSteps: Array<Step> = [
    {
      target: '#workforce',
      disableBeacon: true,
      content: t('thisWidgetProvidesAnOverviewOfWorkforce'),
    },
    {
      target: '#timesheets-locations',
      disableBeacon: true,
      content: t('thisIsTheTimesheetsLocationFilter'),
    },
    {
      target: '#select-period',
      disableBeacon: true,
      content: t('selectThePeriodYourWantToViewInTheTimesheets'),
    },
    {
      target: '#guide-arrows',
      disableBeacon: true,
      content: t('useTheseArrowsToNavigate'),
    },
    {
      target: '#avatar-status',
      disableBeacon: true,
      content: (
        <Box>
          <Typography variant="body1" gutterBottom>
            {t('eachAvatarHasAStatusBadge')}
          </Typography>
          <List component="ol">
            <ListItem>
              <BadgeStatus
                status="Active"
                name={personnel?.name}
                avatar={personnel.avatarFile}
              />
              <Typography pl={1} variant="caption">
                {startCase(personnel.name)}
              </Typography>
            </ListItem>
            <ListItem>
              <BadgeStatus
                status="inActive"
                name={personnel?.name}
                avatar={personnel.avatarFile}
              />
              <Typography pl={1} variant="caption">
                {startCase(personnel.name)}
              </Typography>
            </ListItem>
            <ListItem>
              <BadgeStatus
                status="inBreak"
                name={personnel?.name}
                avatar={personnel.avatarFile}
              />
              <Typography pl={1} variant="caption">
                {startCase(personnel.name)}
              </Typography>
            </ListItem>
          </List>
        </Box>
      ),
    },
    {
      target: '#view-timesheets',
      disableBeacon: true,
      content: t('clickHereToNavigateToTheTimesheets'),
    },
  ];

  return (
    <TourGuide steps={tourSteps} run={runTour} onFinish={() => setRunTour(false)} />
  );
};

export {
  TimesheetsTour,
};
